import { useRouter } from "next/router";
import { Menu, Status } from "~components";
import { useFacebookPixelScripts } from "~features/analytics/useThirdpartyScripts";
import { Detail } from "~features/events/components/EventDetails/EventDetails";
import { useCampaignReportingOpen } from "~hooks/useBroadastCampaignReporting";
import { useEventAccessControl } from "~hooks/useEventAccessControl";
import { useEventTrackingCodes } from "~hooks/useEventTrackingCodes";
import { useGoogleAnalyticsPageView } from "~hooks/useGoogleAnalytics";
import { Event } from "~graphql/sdk";
import { useIsMobile } from "~hooks";
import { MenuEventHeader } from "~components/common/Menu/menu.EventHeader";
import { useContext } from "react";
import { BaseContext } from "~context";

const EventInfoPage = () => {
  const router = useRouter();

  const {
    isLoading,
    event,
    error,
    release,
    accessType,
  } = useEventAccessControl();
  const isMobile = useIsMobile();
  const { isSinglePage } = useContext(BaseContext);
  useCampaignReportingOpen(!isLoading);
  useEventTrackingCodes();

  useFacebookPixelScripts(event?.pixelId);

  return (
    <>
      <Menu>
        {!isLoading && isMobile && isSinglePage && event && (
          <MenuEventHeader event={event as Event}></MenuEventHeader>
        )}
      </Menu>
      <Status loading={isLoading} error={error}>
        <Detail accessType={accessType} event={event} release={release} />
      </Status>
    </>
  );
};

export default EventInfoPage;
